module.exports = __webpack_public_path__ + "img/success-circle.7eb08a86.svg";